import { urlTournamentRegisterSuccess } from '@/urls';
import { StatusPage } from '@/components/common/status-page';
import { CheckCircle } from 'lucide-react';

function RegisterSuccess() {
  return (
    <StatusPage
      title="Inscripción creada correctamente"
      description="En unos minutos recibirás un mensaje de confirmación de tu inscripción. Seguí las instrucciones para confirmar tu inscripción."
      icon={CheckCircle}
      effect="confetti"
    />
  );
}

export const route = {
  element: <RegisterSuccess />,
  path: urlTournamentRegisterSuccess(),
};
